import { Container, Grid, Typography, Box, } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import NewsRoomBackPR from '../../../Component/NewsRoomBackPR.js';
import { Helmet } from 'react-helmet';

import { Link } from 'react-router-dom';
// import ListItem from '@mui/material/ListItem';
// import ListItemText from '@mui/material/ListItemText';
// import LaunchIcon from '@mui/icons-material/Launch';

import TCN from "../../../asset/images/media/technuter.webp";
import VRI from "../../../asset/images/media/var-india.webp";
import WNW from "../../../asset/images/media/web-newswire.webp";
import DT from "../../../asset/images/media/dt-logo.webp";
import BNTW from "../../../asset/images/media/bntw.webp";
import OBN from "../../../asset/images/media/odisha-bussiness.webp";
import SPN from "../../../asset/images/media/sports-news.webp";
import CBN from "../../../asset/images/media/cine-buzz.webp";
import BDN from "../../../asset/images/media/biz-dev-news.webp";
import TNE from "../../../asset/images/media/9th-estate.webp";
import FPR from "../../../asset/images/media/for_pressp_release.webp";
import YST from "../../../asset/images/media/your_story.webp";
import CXO from "../../../asset/images/media/cxo-media.webp";
import APN from "../../../asset/images/media/apn-news.webp";


// const caseStudyLinks = [
//     {
//         type: "external",
//         linkTo: "https://technuter.com/top-breaking-news-of-the-day",
//         text: "https://technuter.com/top-breaking-news-of-the-day"
//     },
//     {
//         type: "external",
//         linkTo: "https://varindia.com/news/eric-yuen-joins-decimal-point-analytics-as-head-of-data-science",
//         text: "https://varindia.com/news/eric-yuen-joins-decimal-point-analytics-as-head-of-data-science"
//     },
//     {
//         type: "external",
//         linkTo: "https://www.webnewswire.com/2025/04/08/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science/",
//         text: "https://www.webnewswire.com/2025/04/08/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science/"
//     },
//     {
//         type: "external",
//         linkTo: "https://digitalterminal.in/tech-companies/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science",
//         text: "https://digitalterminal.in/tech-companies/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science"
//     },
//     {
//         type: "external",
//         linkTo: "https://businessnewsthisweek.com/news/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science/",
//         text: "https://businessnewsthisweek.com/news/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science/"
//     },
//     {
//         type: "external",
//         linkTo: "https://odishabiznewz.com/news/eric-yuen-joins-decimal-point-analytics-as-partner-head-of-data-science/",
//         text: "https://odishabiznewz.com/news/eric-yuen-joins-decimal-point-analytics-as-partner-head-of-data-science/"
//     },
//     {
//         type: "external",
//         linkTo: "https://sportsz.news/news/decimal-point-analytics-strengthens-leadership-with-eric-yuen-as-head-of-data-science/",
//         text: "https://sportsz.news/news/decimal-point-analytics-strengthens-leadership-with-eric-yuen-as-head-of-data-science/"
//     },
//     {
//         type: "external",
//         linkTo: "https://cinebuzznews.net/news/eric-yuen-appointed-partner-and-head-of-data-science-at-decimal-point-analytics/",
//         text: "https://cinebuzznews.net/news/eric-yuen-appointed-partner-and-head-of-data-science-at-decimal-point-analytics/"
//     },
//     {
//         type: "external",
//         linkTo: "https://bizdevelopmentnews.com/news/decimal-point-analytics-welcomes-eric-yuen-as-partner-and-head-of-data-science/",
//         text: "https://bizdevelopmentnews.com/news/decimal-point-analytics-welcomes-eric-yuen-as-partner-and-head-of-data-science/"
//     },
//     {
//         type: "external",
//         linkTo: "https://the9thestate.com/news/eric-yuen-takes-lead-as-partner-and-head-of-data-science-at-decimal-point-analytics/",
//         text: "https://the9thestate.com/news/eric-yuen-takes-lead-as-partner-and-head-of-data-science-at-decimal-point-analytics/"
//     },
//     {
//         type: "external",
//         linkTo: "https://www.forpressrelease.com/forpressrelease/650435/4/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science",
//         text: "https://www.forpressrelease.com/forpressrelease/650435/4/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science"
//     },
//     {
//         type: "external",
//         linkTo: "https://yourstory.com/2025/04/startup-news-updates-daily-roundup-april-8-2025",
//         text: "https://yourstory.com/2025/04/startup-news-updates-daily-roundup-april-8-2025"
//     },
//     {
//         type: "external",
//         linkTo: "https://cxomedia.in/movements/decimal-point-analytics-names-eric-yuen-as-partner-and-head-of-data-science/",
//         text: "https://cxomedia.in/movements/decimal-point-analytics-names-eric-yuen-as-partner-and-head-of-data-science/" 
//     },
//     {
//         type: "external",
//         linkTo: "https://www.apnnews.com/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science/",
//         text: "https://www.apnnews.com/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science/"
//     },
// ];


export default function EricYuenHDS() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <>

            <Helmet>
                <meta charset="UTF-8" />
                <title>Eric Yuen Joins Decimal Point Analytics as Partner & Head of Data Science</title>
                <meta name="description" content="Decimal Point Analytics appoints Eric Yuen as Partner and Head of Data Science, strengthening its AI leadership and global financial services expertise." />
                <link rel="canonical" href="https://www.decimalpointanalytics.com/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>


            <Box className='section sec_bg' component='section'>
                <Container maxWidth='lg' className='bdr'>

                    <Grid container spacing={1} alignItems="top" justifyContent='center'>
                        <Grid item lg={8} md={10} sm={12} xs={12}>
                            <Box>
                                <Typography variant='h2' className='subhead skblue al_center'>
                                    News Room
                                </Typography>
                                <Typography variant='h1' className='mainhead blue al_center'>
                                    Decimal Point Analytics Appoints Eric Yuen <span className='lower'>as</span> Partner <span className='lower'>and</span> Head <span className='lower'>of</span> Data Science
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    <Box>
                        <Grid container direction="row"
                            justifyContent="center"
                            alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box className='whitebx'>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        <Link to="/" className="link">Decimal Point Analytics</Link>, a leading AI and data analytics company serving global financial institutions, is pleased to announce the appointment of <a href="https://www.linkedin.com/in/ericyuen100/" target="_blank" rel="noopener noreferrer">Eric Yuen</a>, as Partner and Head of Data Science.
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        Eric joins Decimal Point Analytics with over 20 years of experience at the intersection of finance, technology, and data science. Most recently, he served as Managing Director and Head of Data Science at Blackstone Credit, where he was responsible for building and leading a high-impact data science team supporting both Liquid and Private Credit strategies. Under his leadership, the team drove innovation across investment diligence, market intelligence, and portfolio management.
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        Prior to Blackstone, Eric held a variety of senior leadership roles at JPMorgan Chase & Co. over a distinguished 19-year career. His tenure included overseeing digital strategy and fintech investments, driving enterprise-wide regulatory initiatives, and leading business operations for global commodities and capital management functions.
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        “We are thrilled to welcome Eric Yuen to Decimal Point Analytics,” said Shailesh Dhuri, CEO of Decimal Point Analytics. “His unique blend of financial expertise, technological foresight, and data-driven thinking aligns perfectly with our mission to deliver a performance advantage to our clients. Eric’s leadership will be pivotal as we continue expanding our AI and data science capabilities across global markets.”
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        Eric holds a Bachelor of Commerce in Accounting and Information Systems from the University of New South Wales and is a Certified Practicing Accountant (CPA) from CPA Australia. He has also served on the boards of private companies and educational institutions.
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        Commenting on his appointment, Eric Yuen said, “Decimal Point Analytics has a bold vision for transforming how data and AI drive insights in the financial sector. I’m excited to join a firm that is deeply committed to innovation and look forward to contributing to its next phase of growth.”
                                    </Typography>

                                    <Box mt={1}>
                                        <Typography variant='h4' className='blue jst' gutterBottom>
                                            About Decimal Point Analytics
                                        </Typography>
                                    </Box>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        <Link to="/" className="link">Decimal Point Analytics</Link> is a technology-driven data analytics and AI solutions firm, empowering businesses with actionable insights and automation. With expertise in financial analytics, AI-driven decision support, and digital transformation, we enable clients to optimise operations, mitigate risks, and drive growth. Our global team blends deep domain knowledge with cutting-edge technology, delivering scalable solutions across financial services, healthcare, CPG, and other industries. Headquartered in India, with a presence in the US and UK, we are committed to innovation, precision, and excellence in data-driven decision-making.
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        Our commitment to innovation and excellence has earned us multiple industry accolades. Decimal Point Analytics has been featured in Dun & Bradstreet's premier publication, Leading SMEs of India 2024 & 2022. We were recognised as the ISV of the Year 2023 by Oracle Global Leaders, highlighting our outstanding contributions to the industry. The Indo-French Chamber of Commerce and Industry (IFCCI) awarded us the title of Indian SME of the Year, while ET Edge acknowledged our excellence in innovation in 2023. Additionally, CEO Insights magazine has named us one of the Top 10 Brands in Finance, further reinforcing our position as a leader in data analytics and AI-driven solutions.
                                    </Typography>

                                    <Typography variant='h6' className='black' gutterBottom>
                                        For more information, visit <Link to="/" className="link">www.decimalpointanalytics.com</Link>
                                    </Typography>

                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                    {/* <Box>
                        <Box className='graybbx linkbx' mt={2}>
                            <Grid container spacing={2} alignItems="center" justifyContent='flex-start'>
                                {caseStudyLinks.map((item, index) => (
                                    <Grid item lg={2} md={4} sm={6} xs={12} key={index}>
                                        {item.type === "internal" ? (
                                            <Link to={item.linkTo} className="link">
                                                <Box className="whitebx">
                                                    <ListItem
                                                        secondaryAction={<LaunchIcon fontSize="small" className="black" />}
                                                    >
                                                        <ListItemText primary={item.text} />
                                                    </ListItem>
                                                </Box>
                                            </Link>
                                        ) : (
                                            <a
                                                href={item.linkTo}
                                                className="link"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <Box className="whitebx">
                                                    <ListItem
                                                        secondaryAction={<LaunchIcon fontSize="small" className="black" />}
                                                    >
                                                        <ListItemText primary={item.text} />
                                                    </ListItem>
                                                </Box>
                                            </a>
                                        )}
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Box> */}


                    <Box>
                        <Box className='graybbx' mt={2}>
                            <Grid container spacing={0} alignItems="center" justifyContent='center'>

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://technuter.com/top-breaking-news-of-the-day" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + TCN + ")" }}
                                        ></Box>
                                    </a>
                                </Grid> 

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://varindia.com/news/eric-yuen-joins-decimal-point-analytics-as-head-of-data-science" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + VRI + ")" }}
                                        ></Box>
                                    </a>
                                </Grid> 

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://www.webnewswire.com/2025/04/08/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + WNW + ")" }}
                                        ></Box>
                                    </a>
                                </Grid> 

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://digitalterminal.in/tech-companies/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + DT + ")" }}
                                        ></Box>
                                    </a>
                                </Grid> 

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://businessnewsthisweek.com/news/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + BNTW + ")" }}
                                        ></Box>
                                    </a>
                                </Grid> 

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://odishabiznewz.com/news/eric-yuen-joins-decimal-point-analytics-as-partner-head-of-data-science/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + OBN + ")" }}
                                        ></Box>
                                    </a>
                                </Grid> 

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://sportsz.news/news/decimal-point-analytics-strengthens-leadership-with-eric-yuen-as-head-of-data-science/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + SPN + ")" }}
                                        ></Box>
                                    </a>
                                </Grid> 

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://cinebuzznews.net/news/eric-yuen-appointed-partner-and-head-of-data-science-at-decimal-point-analytics/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + CBN + ")" }}
                                        ></Box>
                                    </a>
                                </Grid> 

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://bizdevelopmentnews.com/news/decimal-point-analytics-welcomes-eric-yuen-as-partner-and-head-of-data-science/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + BDN + ")" }}
                                        ></Box>
                                    </a>
                                </Grid> 

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://the9thestate.com/news/eric-yuen-takes-lead-as-partner-and-head-of-data-science-at-decimal-point-analytics/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + TNE + ")" }}
                                        ></Box>
                                    </a>
                                </Grid> 

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://www.forpressrelease.com/forpressrelease/650435/4/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + FPR + ")" }}
                                        ></Box>
                                    </a>
                                </Grid> 

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://yourstory.com/2025/04/startup-news-updates-daily-roundup-april-8-2025" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + YST + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>  

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://cxomedia.in/movements/decimal-point-analytics-names-eric-yuen-as-partner-and-head-of-data-science/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + CXO + ")" }}
                                        ></Box>
                                    </a>
                                </Grid> 

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://www.apnnews.com/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + APN + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>  

                            </Grid>
                        </Box>
                    </Box>

                    <Box mt={2}>
                        <NewsRoomBackPR />
                    </Box>

                </Container>
            </Box>

        </>
    );
}
